import { action, observable } from 'mobx';
import { version } from 'mobx-sync';
import { BaseStore } from '~web/store/base/base-store';

@version(1)
export class AuthStore extends BaseStore {
  @observable authenticated: boolean;
  authToken: string;

  setAuthToken(authToken: string): void {
    this.authToken = authToken;
  }

  @action
  login(authToken: string): void {
    this.authToken = authToken;
    this.authenticated = true;
  }

  @action
  logout(): void {
    this.authenticated = false;
    this.authToken = null;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/store/auth-store.ts